const NAMESPACE = "editIncentiveMetadataFieldDialog";

const KEYS = {
    metadataNameLabel: "metadataNameLabel",
    metadataTypeLabel: "metadataTypeLabel",
    metadataTypeSelectorPrompt: "metadataTypeSelectorPrompt",
    textDataTypeText: "textDataTypeText",
    decimalDataTypeText: "decimalDataTypeText",
    metadataOrderLabel: "metadataOrderLabel"
};

const MESSAGES = {
    [KEYS.metadataNameLabel]: {
        value: "Metadata Field Name:",
        comment: "Label for the Metadata Name input in the Edit Metadata Field dialog"
    },
    [KEYS.metadataTypeLabel]: {
        value: "Data Type:",
        comment: "Label for the Metadata Data Type input in the Edit Metadata Field dialog"
    },
    [KEYS.metadataTypeSelectorPrompt]: {
        value: "Select the data type...",
        comment: "Prompt to make a selection in the Metadata Data Type input"
    },
    [KEYS.textDataTypeText]: {
        value: "Text",
        comment: "Text used for the Text Data Type option in the Edit Metadata Field dialog"
    },
    [KEYS.decimalDataTypeText]: {
        value: "Decimal",
        comment: "Text used for the Decimal Data Type option in the Edit Metadata Field dialog"
    },
    [KEYS.metadataOrderLabel]: {
        value: "Order Number:",
        comment: "Label for the Order Number input in the Edit Metadata Field dialog"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
